"use client";
//? Library Imports ------------------------------------------------------------>
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useCallback } from "react";
import { Col, Row, Tag, Space, Skeleton, Typography } from "antd";
import { useRouter } from "next/navigation";

//? Assets --------------------------------------------------------------------->
import { ArrowLeftOutlined } from "@ant-design/icons";

//? Modules -------------------------------------------------------------------->
import AccountStatus from "@/functions/Cookies/Cookies";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import { customerLogout } from "@/functions/Cookies/Cookies";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;
const index = 2;

export default function RewardPoints() {
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    loggedIn,
    comverse_customer_id,
    comverse_customer_email,
    comverse_customer_token,
  } = AccountStatus();
  //? Redux States --------------------------------------------------------------->
  const defaultCurrency = useSelector(
    (state) => state.multiLocation.defaultCurrency
  );

  const [Loading, setLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [RewardPoints, setRewardPoints] = useState({});
  const [RewardHistory, setRewardHistory] = useState({});

  const fetchRewardPoints = useCallback(async () => {
    if (comverse_customer_token) {
      try {
        const payload = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: comverse_customer_token,
          },
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + `/storefront/get_loyalty_cards`,
          payload
        );

        const RewardPoints = await res.json();

        if (!res.ok) {
          if (RewardPoints?.detail === "Invalid auth token") {
            customerLogout();
            dispatch(logoutReducer());
          }
          //logout here
          throw new Error("Reward Points Api Failed!");
        }

        setRewardPoints(RewardPoints);

        if (RewardPoints) {
          setLoading(false);
        }

        return RewardPoints;
      } catch (error) {
        console.error("Reward Points Api Failed!", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  }, [comverse_customer_token]);

  const fetchRewardHistory = useCallback(async (pNo) => {
    if (comverse_customer_token) {
      try {
        const payload = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: comverse_customer_token,
          },
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + `/storefront/get_loyalty_history?page=${pNo}`,
          payload
        );

        const RewardHistory = await res.json();

        if (!res.ok) {
          throw new Error("Reward Points Api Failed!");
        }

        setRewardHistory(RewardHistory);

        if (RewardHistory) {
          setLoading(false);
        }

        return RewardHistory;
      } catch (error) {
        console.error("Reward Points Api Failed!", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  }, [comverse_customer_token]);

  const fetchMoreOrders = async () => {
    const previousResults = RewardHistory?.results;
    const data = await fetchRewardHistory(pageNo + 1);
    setPageNo(pageNo + 1);
    const newResults = data?.results;
    [].push.apply(previousResults, newResults);
    setRewardHistory(prevObject => ({
      ...prevObject,
      results: [...previousResults]
    }));

  }

  useEffect(() => {
    fetchRewardPoints();
  }, [fetchRewardPoints]);

  useEffect(() => {
    fetchRewardHistory(pageNo);
  }, [fetchRewardHistory]);

  return (
    <Col className="RewardPoints">
      <Col span={24} className="padding10">
        <Text className="font14Bold poppinsMedium">Reward Point</Text>
      </Col>

      <Col className="">
        <Row className="gap10">
          <Col span={24} className="padding10">
            <Row className="gap10">
              <Col flex="0 0 48%" className="rewardCard">
                <Space direction="vertical">
                  <Text className="font16">Earned</Text>
                  <Text className="font18Bold">
                    {RewardPoints?.earned} PKR
                  </Text>
                </Space>
              </Col>
              <Col
                flex="0 0 48%"
                className="rewardCard"
                style={{
                  border: "1px solid #000000",
                  boxShadow: "0px 1px 10px #00000080",
                  background: "#FFFFFF 0% 0% no-repeat padding-box",
                }}
              >
                <Space direction="vertical">
                  <Text className="font16">Redeemed</Text>
                  <Text className="font18Bold">
                    {RewardPoints?.redeemed} PKR
                  </Text>
                </Space>
              </Col>
              <Col
                flex="0 0 48%"
                className="rewardCard"
                style={{
                  border: "1px solid #2A1E5C",
                  boxShadow: "0px 1px 10px #9981FF80",
                  background: "#FFFFFF 0% 0% no-repeat padding-box",
                }}
              >
                <Space direction="vertical">
                  <Text className="font16">Available</Text>
                  <Text className="font18Bold">
                    {RewardPoints?.available} PKR
                  </Text>
                </Space>
              </Col>
              <Col
                flex="0 0 48%"
                className="rewardCard"
                style={{
                  border: "1px solid #FDB813",
                  boxShadow: "0px 1px 10px #FFFF8180",
                  background: "#FFFFFF 0% 0% no-repeat padding-box",
                }}
              >
                <Space direction="vertical">
                  <Text className="font16">Pending</Text>
                  <Text className="font18Bold">
                    {RewardPoints?.pending} PKR
                  </Text>
                </Space>
              </Col>
            </Row>
          </Col>

          {RewardHistory?.results?.length > 0 && (
            <Col span={24} className="RewardTable marginTop25 backgroundLight">
              <Row wrap={false}>
                <Col flex="25%" className="font12Bold flexCenter">
                  <Text
                    className="font12 poppinsMedium"
                    style={{ color: "#5A7184" }}
                  >
                    Order No
                  </Text>
                </Col>
                <Col flex="25%" className="font12Bold flexCenter">
                  <Text
                    className="font12 poppinsMedium"
                    style={{ color: "#5A7184" }}
                  >
                    SKU
                  </Text>
                </Col>
                <Col flex="25%" className="font12Bold flexCenter">
                  <Text
                    className="font12 poppinsMedium"
                    style={{ color: "#5A7184" }}
                  >
                    Reward Points
                  </Text>
                </Col>
                <Col flex="25%" className="font12Bold flexCenter">
                  <Text
                    className="font12 poppinsMedium"
                    style={{ color: "#5A7184" }}
                  >
                    Order Date
                  </Text>
                </Col>
              </Row>

              <Col span={24} className="marginTop10">
                {RewardHistory?.results?.map((record, index) => {
                  return (
                    <Row
                      key={index}
                      wrap={false}
                      style={{ height: "auto" }}
                      className={
                        index % 2 === 0 ? "tableRow rowColor" : "tableRow"
                      }
                    >
                      <Col flex="25%" className="flexCenter">
                        <Text className="font12" style={{ color: "#333333" }}>
                          {record?.order_name ? record?.order_name : "N/A"}
                        </Text>
                      </Col>
                      <Col flex="25%" className="flexCenter" style={{ padding: "5px 10px" }}>
                        <Text className="font12" style={{ color: "#333333" }}>
                          {record?.sku ? record?.sku : "N/A"}
                        </Text>
                      </Col>
                      <Col flex="25%" className="flexCenter flexColumn">
                        <Space direction="vertical" className="gap0 flexCenter">
                          <Text className="font12" style={{ color: "#333333" }}>
                            {record?.points ? (record?.points > 0 ? `+${record?.points}` : record?.points) : 0} Pt
                          </Text>
                          <>
                            {
                              record?.status === "pending" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "#fdb813" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "earned" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "green" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "cancelled" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "red" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "redeemed" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "black" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "reverted" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "red" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                          </>
                        </Space>
                      </Col>
                      <Col flex="25%" className="flexCenter">
                        <Text className="font12" style={{ color: "#333333" }}>
                          {record?.created_at ? record?.created_at : "N/A"}
                        </Text>
                      </Col>
                    </Row>
                  );
                })}


                {RewardHistory?.next && (
                  <DynamicButton
                    type="primary"
                    name="Load More"
                    property="danger"
                    className="primary_btn_outline loadMore"
                    function={() => fetchMoreOrders()}
                  />)
                }
              </Col>
            </Col>
          )}
        </Row>
      </Col>
    </Col>
  );
}
